module.exports = __webpack_public_path__ + "img/移载AGV.2d13715d.jpg";